export function getInitialProductDetailsModel(params) {
    const emptyImage = 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAQAAABqrk9lAAAADklEQVR42mNkgANGipkAAYEACAqFE8kAAAAASUVORK5CYII=';
    const imageUrl = params.image.url;
    const smallImage = params.image.smallUrl || params.image.url;
    const mediumImage = params.image.mediumUrl || params.image.url;
    const largeImage = params.image.largeUrl || params.image.url;

    const initialGallery = {
        imageUrl,
        smallImage,
        mediumImage,
        largeImage
    };

    const emptyGallery = {
        imageUrl: emptyImage,
        smallImage: emptyImage,
        mediumImage: emptyImage,
        largeImage: emptyImage
    }

    const gallery = [...Array(params.picturesCount)].map((item, index) => {
        const imageSet = index === 0 ? initialGallery : emptyGallery;
        return Object.assign({}, imageSet, { url: params.url, target: params.mobileTarget });
    });

    return {
        isLoading: true,
        galleryModel: gallery,
        initialGalleryModel: initialGallery,
        price: {
            isPromo: params.discountPercent,
            promo: window.isNaN(params.price) ? params.price : `${params.price.toFixed(2).replace(/[.,]00$/, '')} zł`,
            regular: window.isNaN(params.oldPrice) ? params.oldPrice : `${params.oldPrice.toFixed(2).replace(/[.,]00$/, '')} zł`
        },
        title: params.productName,
        discountPercent: params.discountPercent,
        redirectUrl: params.url,
        shopname: params.shopName,
        shipping: params.shipmentText,
        dropshippingSettings: params.dropshippingSettings,
        sizes: params.sizesText.split('|').map(size => size.trim()),
        coupon: params.coupon,
        productId: params.productId,
        isActive: !params.isNotActive,
        mobileTarget: params.mobileTarget,
        productName: params.mobileProductName,
        position: params.position,
        isCosExcluded: params.isCosExcluded,
        isInListing: params.isInListing,
        isInPromoSales: params.isInPromoSales,
        isNewProduct: params.isNewProduct,
        isDiscountHunters: params.isDiscountHunters,
        isLastItems: params.isLastItems,
        isBestseller: params.isBestseller,
        freeShipping: params.freeShipping,
        promoSaleBadgeImageUrl: params.promoSaleBadgeImageUrl,
        promoSaleBadgeLargeImageUrl: params.promoSaleBadgeLargeImageUrl
    };
}

export function getStaticProductDetailsModel(params) {
    return {
        brand: {
            brandCategoryUrl: params.category.url,
            name: params.product.brandName
        },
        brandModel: params.brandModel,
        categoriesDescriptionModel: params.categoriesDescriptionModel,
        categoryUrl: params.category.url,
        categoryName: params.category.name,
        coupon: params.coupon,
        description: params.product.description,
        tagGroups: params.productsDescriptionTags.groups.map((group) => {
            const commaSeparatedTags = group.tags.map(elem => elem.name).join(', ');
            return Object.assign({}, { ...group }, { commaSeparatedTags });
        }),
        discountPercent: params.discountFormat,
        productId: params.product.productId,
        galleryModel: (() => {
            if (params.isActive) {
                return params.mobilePictures.map(item => {
                    const props = {
                        url: params.redirectUrl,
                        imageUrl: item.pictureUrl,
                        smallImage: item.smallPictureUrl,
                        mediumImage: item.mediumPictureUrl,
                        largeImage: item.largePictureUrl,
                        target: params.mobileTarget,
                        name: item.alt || ''
                    };
                    return { ...item, ...props };
                });
            } else {
                return params.smallPictures.slice(0, 4).map(item => {
                    return { ...item, imageUrl: item.pictureUrl }
                });
            }
        })(),
        isActive: params.isActive,
        isLoading: false,
        isLightbox: false,
        like: params.likeComponent,
        mobileTarget: params.mobileTarget,
        price: params.price,
        productName: params.brandModel && params.brandModel.brandName || params.product.shopName,
        redirectUrl: params.redirectUrl,
        productSections: params.productSections,
        shopname: params.product.shopName,
        shipping: params.shippingFormat,
        dropshippingSettings: params.dropshippingSettings,
        shortDescription: params.product.shortDescription,
        sizes: params.product.sizes,
        title: params.productNameForHeader,
        trends: params.trends,
        productsUrlForInactiveProduct: params.productsUrlForInactiveProduct,
        productsButtonTextForInactiveProducts: params.productsButtonTextForInactiveProducts,
        shippingDetails: params.shippingDetails,
        isInPromoSales: params.product.isInPromoSales,
        isNewProduct: params.product.isNewProduct,
        isDiscountHunters: params.product.isDiscountHunters,
        isLastItems: params.product.isLastItems,
        isBestseller: params.product.isBestseller,
        freeShipping: params.freeShipping,
        promoSaleBadgeImageUrl: params.promoSaleBadgeImageUrl,
        promoSaleBadgeLargeImageUrl: params.promoSaleBadgeLargeImageUrl
    };
}

export function fetchProductDetailsModel(id, query) {
    return new Promise((resolve, reject) => {
        DM.Service.Product.getProduct(id, query).then(data => {
            const productProps = {
                isLoading: false,
                categoryName: data.brand && data.brand.categoryName,
                productName: data.brandModel && data.brandModel.brandName || data.shopname,
                galleryModel: (() => {
                    if (data.isActive) {
                        return data.images.map(item => {
                            const props = {
                                url: data.redirectUrl,
                                imageUrl: item.pictureUrl,
                                smallImage: item.smallPictureUrl,
                                mediumImage: item.mediumPictureUrl,
                                largeImage: item.largePictureUrl,
                                target: '_blank'
                            };
                            return { ...item, ...props };
                        });
                    } else {
                        return data.images.slice(0, 4).map(item => {
                            return { ...item, imageUrl: item.srcSmall }
                        });
                    }
                })(),
                tagGroups: data.descriptionTags.groups.map((group) => {
                    const commaSeparatedTags = group.tags.map(elem => elem.name).join(', ');
                    return Object.assign({}, { ...group }, { commaSeparatedTags });
                }),
            };
            const model = Object.assign({}, data, productProps);
            resolve(model);

        }).catch(e => {
            reject(e);
        });
    });
}

export function getLikes(likeModel) {
    return new Promise((resolve, reject) => {
        const likeId = `pr${likeModel.id}`;
        const likes = likeModel.count;

        DM.Service.Likes.getUserLikes([likeId]).then(response => {
            const id = `pr${likeModel.id}`;
            const like = {
                productId: likeModel.id,
                likes,
                id,
                liked: response[0] === id
            };

            const likeData = Object.assign({}, likeModel, like);
            resolve(likeData);
        }).catch(e => {
            reject(e);
        });
    });
}

export function getSections(id) {
    return new Promise((resolve, reject) => {
        DM.Service.Product.getSections(id).then(response => {
            resolve(response);
        }).catch(e => {
            reject(e);
        });
    });
}
